import { service } from '../api/axios';

export const postSubject = async (label: string) => {
  await service
    .post(`/subjects`, { label })
    .then((responseFromAPI) => responseFromAPI.data);
};

export const deleteSubject = async (id: string) => {
  await service
    .delete(`/subjects/${id}`)
    .then((responseFromAPI) => responseFromAPI.data);
};
